import { ReactNode } from 'react'
import { useFormikContext } from 'formik'
import { Button } from '@mui/material'

import { ButtonProgress } from '../button-progress'
import { EditIcon } from 'src/assets/icons'

import { useStyles } from './styles'

interface IFormSubmitButtonProps {
  validText: string | ReactNode
  invalidText: string | ReactNode
  withoutIcon?: boolean
  notDisabledIfDirty?: boolean
  disabled?: boolean
}

const FormSubmitButton = ({
  disabled,
  validText,
  invalidText,
  withoutIcon,
  notDisabledIfDirty,
}: IFormSubmitButtonProps) => {
  const { isSubmitting, errors, dirty } = useFormikContext()

  const classes = useStyles({ withoutIcon })

  const validToSubmit = (notDisabledIfDirty || dirty) && Object.keys(errors).length === 0

  return (
    <Button
      variant="contained"
      startIcon={withoutIcon ? null : <EditIcon />}
      className={classes.formButton}
      type="submit"
      disabled={isSubmitting || !validToSubmit || disabled}
    >
      {isSubmitting ? <ButtonProgress /> : validToSubmit ? validText : invalidText}
    </Button>
  )
}

export { FormSubmitButton }
